"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatTypes = exports.ChatFeedback = void 0;
const ChatFeedback = exports.ChatFeedback = {
  POSITIVE: 'POSITIVE',
  NEGATIVE: 'NEGATIVE'
};
const ChatTypes = exports.ChatTypes = {
  ENTER_CUSTOMER_SERVICE: 'ENTER_CUSTOMER_SERVICE',
  EXIT_CUSTOMER_SERVICE: 'EXIT_CUSTOMER_SERVICE'
};